import React from "react";
import CmsManager from "../CMS/CmsManager";

function PrivacyList() {
  return (
    <CmsManager
      title="Privacy Policy"
      resource="privacy-policy"
      singleton
      fields={[
        { name: "title", label: "Page Title", fullWidth: false, defaultValue: "Privacy Policy" },
        { name: "content", label: "Privacy Policy Content", type: "richtext" },
        { name: "slug", label: "URL Slug", fullWidth: false, defaultValue: "privacy-policy" },
        { name: "metaTitle", label: "Title Tag", fullWidth: false },
        { name: "metaDescription", label: "Meta Description", type: "textarea", rows: 3 },
        { name: "metaKeywords", label: "Meta Keywords", type: "keywords", rows: 2 },
      ]}
    />
  );
}

export default PrivacyList;
